import $ from 'jquery';
import Disclosure from '@pixelunion/shopify-cross-border';

export default class Sidebar {
  constructor() {
    this.$scripts = $('[data-scripts]');
    this.$body = $(document.body);
    this.$overlay = $('.content-overlay');

    this.bindElements();
    this._bindEvents();
  }

  bindElements() {
    this.$sidebar = $('.main-sidebar');
    this.$productSidebar = $('.product-sidebar');

    this.overnav = {
      $open: $('[data-overnav-open]'),
      $close: $('[data-overnav-close]'),
      $nav: $('[data-overnav]'),
      $overlay: $('[data-overnav-overlay]'),
    };
  }

  isExtended() {
    return this.$body.hasClass('sidebar-extended');
  }

  toggleExtended(callback, toggle) {
    const state = toggle === undefined
      ? !this.isExtended()
      : toggle;

    if (callback) {
      const $el = this.$productSidebar.length
        ? this.$productSidebar
        : this.$sidebar;

      $el.one('trend', callback);
    }

    this.$body.toggleClass('sidebar-extended', state);
    this.toggleOverlay(state);
  }

  toggleOverlay(toggle) {
    if (toggle === undefined) {
      this.$overlay.revealer();
    } else {
      this.$overlay.revealer(toggle ? 'show' : 'hide');
    }

    this.$body.toggleClass('overlay-visible', toggle);
  }

  _isExpanded($el) {
    return $el.attr('aria-expanded') === true;
  }

  _toggleOvernav(show = true) {
    const state = show ? 'show' : 'hide';

    this.overnav.$open.ariaExpanded(show);
    this.overnav.$close.ariaExpanded(show);
    this.overnav.$nav.revealer(state);
    this.overnav.$overlay.revealer(state);
  }

  _bindEvents() {
    // Open/close nav modal
    this.$body.on('click', '[data-overnav-open]', (event) => {
      event.preventDefault();
      this._toggleOvernav(true);
    });

    this.$body.on('click', '[data-overnav-close]', (event) => {
      event.preventDefault();
      this._toggleOvernav(false);
    });

    this.$body.on('click', '[data-overnav-overlay]', (event) => {
      event.preventDefault();
      this._toggleOvernav(false);
    });

    // Open/close navigation submenus
    this.$body.on('click', '.navigation-parent-link', (event) => {
      event.preventDefault();
      const $link = $(event.currentTarget);
      const $submenu = $link.siblings('.navigation-menu');

      $link.ariaExpanded(!this._isExpanded($link));
      $submenu.slideToggle(200);
    });
  }
}
